import React, { useMemo } from 'react';

import { Tooltip } from '@mui/material';
import { format } from 'date-fns';
import { OrderDetails } from '../core/global';


export interface OrderSummaryProps {
  orderDetails: OrderDetails | null
}

export const OrderSummary = ({
  orderDetails,
}: OrderSummaryProps ) => {

  const {
    paymentType,
    createdAt,
    transactionId,
    paymentMethod,
    paymentId,
    isApiAcquisition
  } = useMemo(() => {
    if (orderDetails) {
      const { is_api_acquisition, type, created_at, transaction_id, payment_method, payment_id } = orderDetails
      return { 
        paymentType: type,
        createdAt: created_at,
        transactionId: transaction_id,
        paymentMethod: payment_method, 
        paymentId: payment_id,
        isApiAcquisition: is_api_acquisition || false
       }
    }
    return { paymentType: null }
  }, [orderDetails])

  return (
    <>
      {createdAt && typeof createdAt === 'string' && <p>Order placed: <strong>{format(new Date(createdAt), 'd MMMM yyy (HH:mm)')} GMT</strong></p>}
      {isApiAcquisition && <p>This order has been completed via <strong>API acquisition</strong>.</p>}
      {transactionId && <p>Transaction ID: <strong>{transactionId}</strong></p>}
      {paymentMethod === 'stripe' && 
        <p>
          This order has been processed by <Tooltip
            title={paymentId} 
            placement="bottom" 
            arrow
          ><strong>Stripe</strong></Tooltip>.
        </p>
      }
      {paymentMethod === 'tokens' && 
        <p>
          This order has been paid by <strong>Tokens</strong>.
        </p>
      }
      {paymentMethod === 'subscription' && 
        <p>
          This order has been paid by your <strong>Subscription</strong>.
        </p>
      }
    </>
  )
}
